import React from 'react';
import { Box, Chip } from '@mui/material';

/**
 * 그룹 정보를 표시하는 셀 컴포넌트
 * 
 * @param {Object} props
 * @param {Object} props.row - DataGrid의 row 객체
 * @param {Object} props.row.group - 그룹 정보 객체
 * @param {string} props.row.group.groupName - 고객사명
 * @param {string} props.row.group.groupCourse - 그룹명
 * @param {number} props.row.group.groupCourseCount - 차수
 */
const GroupCell = ({ row }) => {
  const group = row.group;
  
  // group이 없는 경우 빈 문자열 반환
  if (!group) return '-';
  
  // groupName(고객사)을 Chip으로 표시하고, 그룹명과 차수를 텍스트로 표시
  const groupText = `${group.groupCourse} ${group.groupCourseCount}차수`;
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Chip
        label={group.groupName}
        size="small"
        variant="outlined"
        color="primary"
      />
      <span>{groupText}</span>
    </Box>
  );
};

export default GroupCell;
